import { render } from "./DossiersList.vue?vue&type=template&id=fd61fa08&scoped=true"
import script from "./DossiersList.vue?vue&type=script&lang=js"
export * from "./DossiersList.vue?vue&type=script&lang=js"

import "./DossiersList.vue?vue&type=style&index=0&id=fd61fa08&lang=scss&scoped=true"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd61fa08"]])

export default __exports__